/*@flow*/
import type { Node, Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import Checkbox from './Checkbox';
import useCachedQuery from 'lib/useCachedQuery';
import GetAlertsAndSubscriptions from './queries/GetAlertsAndSubscriptions';
import * as I from 'immutable';
import ErrorsView from 'comps/ErrorsView';

type PropsT = { districtId: ID };
type TemplateT = { name: string, label: string };
type SubscriptionT = { id: ID, templateName: string };

const cssChechboxMenu = css(`
  width: 100%;
  background: white;
  padding: 0;
`);

const Component = (props: PropsT): Element<string> | Node => {
  const { districtId } = props;
  const variables = { districtId };
  const opts = { variables };
  const queryRes = useCachedQuery(GetAlertsAndSubscriptions, opts);
  const { data, error, loading, errors } = queryRes;
  const templatesPath = ['me', 'district', 'alertTemplates'];
  const subsPath = ['me', 'district', 'alertSubscriptions'];
  const templates: TemplateT[] = I.getIn(data, templatesPath, []);
  let subscriptions: SubscriptionT[] = I.getIn(data, subsPath, []);
  const subscribedTemplates = subscriptions.map(
    ({ templateName }) => templateName
  );

  const options: { value: string, label: string }[] = templates.map(
    ({ name, label }) => ({ value: name, label })
  );
  const valueToId = subscriptions.reduce(
    (s, { id, templateName }) => ({
      ...s,
      [templateName]: id,
    }),
    {}
  );
  const subOptions = options.filter((o) =>
    subscribedTemplates.includes(o.value)
  );
  const alertOptions = options.filter(
    (o) => !subscribedTemplates.includes(String(o.value))
  );

  if (loading) {
    return (
      <div className="text-flex-center" css={cssChechboxMenu}>
        Loading...
      </div>
    );
  }
  if (error || errors) return <ErrorsView errors={errors} error={error} />;

  return (
    <div css={cssChechboxMenu}>
      <h5>Subscriptions</h5>
      {subOptions.map((o, index) => {
        return (
          <Checkbox
            key={`${o.label}${index}Subscriptions`}
            id={valueToId[o.value]}
            label={o.label}
            value={o.value}
            districtId={districtId}
            checked={subscribedTemplates.includes(o.value)}
          />
        );
      })}
      {subOptions.length === 0 && <div>None</div>}
      {alertOptions.length > 0 && <hr />}
      {alertOptions.map((o, index) => {
        return (
          <Checkbox
            key={`${o.label}${index}`}
            id={valueToId[o.value]}
            label={o.label}
            value={o.value}
            districtId={districtId}
            checked={subscribedTemplates.includes(o.value)}
          />
        );
      })}
    </div>
  );
};

export default Component;
